import { PaymentTransactionTypeEnum } from './payment-transaction-type-enum';

export class PaymentTransaction {
  paymentDate: Date = null;

  get paymentTransactionType(): PaymentTransactionTypeEnum {
    throw new Error('Not Implemented');
  }
}
